import Api from '../../Api';
import { IPagedRequest } from '../../shared-interfaces/IPagedRequest';
import { IPagedResponse } from '../../shared-interfaces/IPagedResponse';
import { INotation } from '../../shared-interfaces/Notation/INotation';
import { INotationComment } from '../../shared-interfaces/Notation/INotationComment';
import { AlertStatus } from '../../shared-types/Notation/AlertStatus';
import { NotationType } from '../../shared-types/Notation/NotationType';
import { Role } from '../../shared-types/Roles';

export interface INotationSearchRequest {
  userId?: string;
  role?: Role;
  studentId?: string;
  createdById?: string;
  createdForId?: string;
  canStudentView?: boolean;
  audienceTypes?: string[];
  notationTypes?: NotationType[];
  fromDate?: string;
  toDate?: string;
  takeTop?: number;
  orderByDescending?: boolean;
  onlyMyStudents?: boolean;
  institutionId?: number;
  categoryIds?: number[];
  assignedToId?: string;
  onlyUnassigned: boolean;
  alertStatus?: AlertStatus[];
}

export interface INotationCommentRequest {
  successNotificationId: number;
}

const NotationService = {
  search: async (
    request: IPagedRequest<INotationSearchRequest>,
  ): Promise<IPagedResponse<INotation>> => {
    const response = await Api.post('notations/search', request);
    if (response.status !== 200) throw response.status;
    return {
      ...response.data,
      items: response.data.items.map((x: any) => ({
        ...x,
        createdOn: new Date(x.createdOn),
      })),
    };
  },
  getNotation: async (notationType: string, id: number): Promise<INotation> => {
    const response = await Api.get(`notations/${notationType}/${id}`);
    if (response.status !== 200) throw response.status;
    return response.data;
  },
  getComments: async (
    request: IPagedRequest<INotationCommentRequest>,
  ): Promise<IPagedResponse<INotationComment>> => {
    const response = await Api.post('notations/comments', request);
    if (response.status !== 200) throw response.status;
    return {
      ...response.data,
      items: response.data.items.map((x: any) => ({
        ...x,
        createdOn: new Date(x.createdOn),
      })),
    };
  },
};

export default NotationService;
